import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoleModel } from './role-model';
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
import { ApiMethod } from '../../apimethods/api-method';
declare var $;

@Component({
  selector: 'app-role-master',
  templateUrl: './role-master.component.html',
  styleUrls: ['./role-master.component.css']
})

export class RoleMasterComponent implements OnInit {

  modelItem = new RoleModel();

  @ViewChild('dataTable', { static: false }) table;
  public aMenuList = []; public agridList = [];
  public agridTransList = [];
  dataTable: any;
  dtOptions: any;
  showModal: boolean;
  content: string;
  title: string;
  dataSet: any;
  popUpButtonText: string;
  checkAdmin: boolean = (localStorage.aLoginID == '1' ? true : false)

  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <RoleModel>data["RolePage"];
        this.GetRolesList();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  ngOnInit(): void {
    $('.select2').select2({ dropdownParent: "#myModal" });
    ApiMethod.getBaseUrl();
  }

  ngAfterViewChecked(): void {
    this.UpdateTableHeight();
  }

  UpdateTableHeight() {
    $('#divRoleBody').css('height', GlobalConstants.size.height - 20);
    $('.tblRightsList').css('height', GlobalConstants.size.height - 220);
    $('.tblColumnList').css('height', GlobalConstants.size.height - 240);
  }

  //Load Data List
  GetRolesList(): void {
    $("#LoadingImage").show();
    let npublisherId = localStorage.aPubID;
    ApiMethod.getMethod(this.modelItem.RoleListAPI + localStorage.aLoginID + '/' + npublisherId).subscribe(
      result => {
        console.log(result);
        $("#LoadingImage").hide();
        this.aMenuList = result.aitemMenu;// Data of Menu
        this.agridList = result.gridList;
        this.dataSet = JSON.stringify(result.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'RoleModule';
        dataItem.IdOrder = 'desc';
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable


      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  PopulateGridTransList(): void {
    let itemL = this.agridTransList;
    $.each(itemL, function (i, val) {
      let arowL = $("#tblColumnList tbody tr#tr" + val.TransID);
      if (arowL.length > 0) {
        if (val.ActionView == 'checked')
          $(arowL).find('input[name="View"]').prop('checked', val.ActionView);
        $(arowL).find('input[name="Update"]').prop('checked', val.ActionEdit);
      }
    });
  }

  GetGridTrasList(): void {
    $("#LoadingImage").show();

    ApiMethod.getMethod(this.modelItem.GetGridTransList + '/' + $('#ddlGridName').val() + '/' + localStorage.aEID).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.agridTransList = result.aitemList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });

    $('.chkColumnAll').change(function () {
      if ($(this).is(':checked'))
        $('.chkColAction').not('[disabled="disabled"]').prop('checked', 'checked');
      else
        $('.chkColAction').not('[disabled="disabled"]').prop('checked', false);
    });
  }

  //Update Role details method
  UpdateRoleDetails(): void {
    if ($('#txtRoleName').val() == '') {
      ngswal("Warning !", "Please enter a valid role name !", "warning");
    }
    else {
      $("#LoadingImagePopup").show();
      var getAccesList = GlobalConstants.GetTableRowToList('tblRightsList', null);
      var getGridTransList = GlobalConstants.GetTableRowToList('tblColumnList', null);
      var User = {
        RoleID: localStorage.aEID,
        RoleName: $('#txtRoleName').val(),
        Description: $('#txtDescription').val(),
        DashboardLink: $('#txtDashboardLink').val(),
        DashboardMenuId: $('#ddlDashboardLink').val(),
        IsVisibleHeaderIcon: $('#chkIsVisibleHeaderIcon')[0].checked,
        UpdatedBy: localStorage.aLoginID,
        AccessList: JSON.stringify(getAccesList),
        GridTransList: JSON.stringify(getGridTransList)
      };

      ApiMethod.postMethod(this.modelItem.UpdateAPI, User).subscribe(
        resonse => {
          this.GetRolesList();
          $("#LoadingImagePopup").hide();
          this.hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: resonse,
            showConfirmButton: false,
            timer: 1500
          });
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );

    }
  }

  clearData(): void {
    $('#txtRoleName').val('');
    $('#txtDescription').val('');
    $('.chkAction,.chkColAction').prop('checked', false);
    $("#LoadingImage").hide();
    $('.chkActionAll,.ChkColumnAll').prop('checked', false);
  }

  //Show Rolemaster control popup
  show(): void {
    this.clearData();
    if (localStorage.aEID != 0) {
      $("#LoadingImage").show();
      ApiMethod.getMethod(this.modelItem.GetRoleByIdAPI + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImage").hide();
          let itemL = result.aitemList;
          $('#txtRoleName').val(itemL[0].RoleName);
          $('#txtDescription').val(itemL[0].Description);
          $('#txtDashboardLink').val(itemL[0].DashboardLink);
          $('#chkIsVisibleHeaderIcon').prop('checked', itemL[0].IsVisibleHeaderIcon);

          $.each(itemL, function (i, val) {
            let arowL = $("#tblRightsList tbody tr#tr" + val.MenuID);
            if (arowL.length > 0) {
              $(arowL).find('input[name="View"]').prop('checked', val.ActionView);
              $(arowL).find('input[name="Add"]').prop('checked', val.ActionAdd);
              $(arowL).find('input[name="Update"]').prop('checked', val.ActionEdit);
              $(arowL).find('input[name="Delete"]').prop('checked', val.ActionDelete);
              $(arowL).find('input[name="Clone"]').prop('checked', val.ActionClone);
            }
          });

          this.GetGridTrasList();
        },
        error => {
          ngswal("Failed !", error.message, "warning");
        }
      );
      this.popUpButtonText = "Update";
    } else {
      this.popUpButtonText = "Add";
    }
    this.showModal = true; // Show-Hide Modal Check
    this.title = "Role Details";    // Dynamic Data
    $('.chkActionAll').change(function () {
      if ($(this).is(':checked'))
        $('.chkAction').not('[disabled="disabled"]').prop('checked', 'checked');
      else
        $('.chkAction').not('[disabled="disabled"]').prop('checked', false);
    });
  }

  //Bootstrap Modal Close event
  hide() {
    this.clearData();
    this.showModal = false;
  }

}
